import {
  BarChart,
  Bar,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  Legend,
  YAxis,
  Text,
} from "recharts"
import { chartColours } from "../Charts/chart-util"

export default function StackedBarView({
  data,
  dataKeys,
  tooltipContent,
  formatter,
  printAsPDF,
  colour,
  yAxisLabel,
}) {
  const maxValue = formatter(data[0].value) || formatter(0)
  const additionalWidth = maxValue.toString().split("").length * 5

  return (
    <ResponsiveContainer>
      <BarChart
        data={data}
        margin={{
          top: 5,
          right: 30,
          left: 20,
          bottom: 5,
        }}
        stackOffset="sign"
        barCategoryGap={0}
      >
        <XAxis
          dataKey="name"
          className="transform"
          tick={true}
          interval={null}
          style={{ fontSize: "12px" }}
        />
        <YAxis
          label={
            <Text
              style={{ fontSize: "12px" }}
              fill="gray"
              dx={5}
              dy={printAsPDF ? 120 : 130}
              verticalAnchor="middle"
              textAnchor="middle"
              angle={-90}
            >
              {yAxisLabel}
            </Text>
          }
          tickFormatter={formatter}
          style={{ fontSize: "12px" }}
          width={20 + additionalWidth}
        />
        <Tooltip content={tooltipContent} />
        <Legend
          layout="horizontal"
          align="center"
          verticalAlign="top"
          wrapperStyle={{
            fontSize: "12px",
            textOverflow: "ellipsis",
            overflow: "hidden",
          }}
          fill={colour}
        />
        {dataKeys.map((key, index) => (
          <Bar
            key={index}
            dataKey={key}
            isAnimationActive={false}
            radius={[0, 0, 0, 0]}
            stackId="stack"
            fill={chartColours[index]}
          ></Bar>
        ))}
      </BarChart>
    </ResponsiveContainer>
  )
}
